module.exports = __webpack_public_path__ + "static/media/log1.48d741de.jpg";